import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Loader from '@/lib/components/Loader';

import styles from './../PaymentPage.module.scss';

const Cart = ({ summaryLoading, paymentRequestToken }) => {
    const { t } = useTranslation();
    const displayedPrice = t(
        'price.' + paymentRequestToken?.currency,
        {
            count: (paymentRequestToken?.amount / 100).toFixed(2),
            defaultValue: `${(paymentRequestToken?.amount / 100).toFixed(2)} ${paymentRequestToken?.currency}`,
        },
    );

    return <div className={styles.content_right_container}>
        <div className={styles.summary}>
            <div className={styles.summary_header}>{t('orderSummary')}</div>
            {summaryLoading ?
                <Loader />
                :
                <div className={styles.summary_content}>
                    <div className={styles.price}>
                        <div className={styles.price_label}>{t('total')}</div>
                        <div className={styles.price_value}>{displayedPrice}</div>
                    </div>
                </div>
            }
        </div>
        <div className={styles.normal_rate}>
            {summaryLoading ? (
                <Loader />
            ) : (
                paymentRequestToken?.articles?.length > 0 && (
                    <div className={styles.normal_rate_content}>
                        {paymentRequestToken?.articles.map((article, key) => (
                            <div className={styles.rates} key={key}>
                                <div>{article.name}</div>
                                <div>{article.qty}</div>
                                <div className={styles.price}>
                                    {t('price.' + paymentRequestToken?.currency, {
                                        count: (article.price / 100).toFixed(2),
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                )
            )}
        </div>
    </div>;
};

Cart.propTypes = {
    paymentRequestToken: PropTypes.object,
    summaryLoading: PropTypes.bool,
};

export default Cart;
